import { PackageScanModesFormWebComponent } from './component/PackageScanModesFormWebComponent';
import { WEB_COMPONENT_PACKAGE_SCAN_MODES_FORM } from '../../../webcomponents.constants';

export { PackageScanModesFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_SCAN_MODES_FORM, PackageScanModesFormWebComponent);
